import { Pipe, PipeTransform } from '@angular/core';
import { resolveThemeBackground } from '../utils/theme-color.util';

/** Resolve theme_color (legacy token or CSS) for safe [style.background] binding. */
@Pipe({
  name: 'themeBackground',
  standalone: true,
  pure: true,
})
export class ThemeBackgroundPipe implements PipeTransform {
  transform(value: string | null | undefined): string | null {
    return resolveThemeBackground(value);
  }
}
